import { render } from "./TicketList.vue?vue&type=template&id=33341bfd&scoped=true"
import script from "./TicketList.vue?vue&type=script&lang=js"
export * from "./TicketList.vue?vue&type=script&lang=js"

import "./TicketList.vue?vue&type=style&index=0&id=33341bfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33341bfd"]])

export default __exports__